import { render, staticRenderFns } from "./ReportExtraCurricular.vue?vue&type=template&id=c70dacd8&scoped=true&"
import script from "./ReportExtraCurricular.vue?vue&type=script&lang=js&"
export * from "./ReportExtraCurricular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70dacd8",
  null
  
)

export default component.exports